/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function SearchIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={25}
      fill='none'
      {...props}
    >
      <mask
        id='search_svg__a'
        width={24}
        height={25}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 .988h24v24H0z' />
      </mask>
      <g mask='url(#search_svg__a)'>
        <path
          fill='#232B3A'
          d='m19.6 21.988-6.3-6.3q-.75.6-1.725.95t-2.075.35q-2.725 0-4.612-1.887T3 10.488q0-2.724 1.888-4.613Q6.775 3.988 9.5 3.988t4.613 1.887Q16 7.764 16 10.488a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312Q14 12.363 14 10.488q0-1.874-1.312-3.188Q11.375 5.99 9.5 5.988q-1.875 0-3.188 1.312Q5 8.614 5 10.488t1.312 3.188q1.313 1.312 3.188 1.312'
        />
      </g>
    </svg>
  )
}
